module.exports = __webpack_public_path__ + "img/lobby5.7aea685e.jpg";